export const WEB_LINKS = {
  // Github 主页
  GITHUB_HOME: 'https://github.com/Daymychen',

  // 项目 Github 主页
  GITHUB: 'https://github.com/Daymychen/art-design-pro',

  // 个人博客
  BLOG: 'https://www.lingchen.kim',

  // 项目文档
  DOCS: 'https://www.lingchen.kim/art-design-pro/docs',

  // 项目社区
  COMMUNITY: 'https://www.lingchen.kim/art-design-pro/docs/zh/community/communicate.html',

  // 个人 Bilibili 主页
  BILIBILI: 'https://space.bilibili.com/425500936?spm_id_from=333.1007.0.0',

  // 项目介绍
  INTRODUCE: 'https://www.lingchen.kim/art-design-pro/docs/guide/introduce.html'
}
